// === LA CONCIERGERIE — Point d'entrée Vite (Vague 4 complète) ===
import './style.css'
import React from 'react'
import ReactDOM from 'react-dom/client'

// Tous les modules sont importés dans App.jsx via la chaîne d'imports
// main.jsx n'a qu'à monter App
import { App, ErrorBlackbox, MemoryGauge } from './components/App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'

const rootEl = document.getElementById('root')
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.Fragment>
      <ErrorBlackbox/>
      <MemoryGauge/>
      {/* ErrorBoundary n'enveloppe QUE <App/> : si le filet lui-même plantait,
          ErrorBlackbox resterait monté et continuerait de journaliser. */}
      <ErrorBoundary>
        <App/>
      </ErrorBoundary>
    </React.Fragment>
  )
}
